import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useUserPermissions } from "../../UserPermissionsContext";
import Cookies from "js-cookie";
import { Modal } from "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

type PasswordField = "password" | "newPassword" | "confirmPassword";


interface ErrorMessage {
  username?: string[];
  password?: string[];
  error?: string[];
}

interface PasswordVisibility {
  password: boolean;
  newPassword: boolean;
  confirmPassword: boolean;
}

const Login2 = () => {
  const routes = all_routes;
  const navigation = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFirstLogin, setIsFirstLogin] = useState();
  const [errorMessage, setErrorMessage] = useState<ErrorMessage>({});
  const [newPassword, setNewPassword] = useState("");
  const [dashboardRedirection, setDashboardRedirection] = useState("");
  const { webApi } = useUserPermissions();
  const [confirmPassword, setConfirmPassword] = useState("");
  const { setUserPermissions, setUserData, setUserProfile } =
    useUserPermissions();
  const [passwordVisibility, setPasswordVisibility] =
    useState<PasswordVisibility>({
      password: false,
      newPassword: false,
      confirmPassword: false,
    });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const navigateToDashboard = () => {
    if (dashboardRedirection === "Wizklub Dashboard") {
      navigation(routes.adminDashboard1);
    } else if (dashboardRedirection === "Employee Dashboard") {
      navigation(routes.employeeDashboard);
    } else {
      navigation(routes.crmLandingPage);
    }
  };

  // useEffect(() => {
  //   const handleResize = () => setWidth(window.innerWidth);
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  useEffect(() => {
    if (isLoggedIn) {
      if (isFirstLogin) {
        // Show the update password modal
        const modalElement = document.getElementById("updatepassword");
        if (modalElement) {
          const modal = new Modal(modalElement);
          modal.show();
        }
      } else if (isFirstLogin !== undefined) {
        navigateToDashboard();
      }
    }
  }, [isLoggedIn, isFirstLogin, navigation, routes]);

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(`${webApi}/user/login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData);
        throw new Error(errorData.detail || "Invalid email or password");
      }

      const data = await response.json();
      setUsername("");
      setPassword("");

      if (!data) {
        throw new Error("No data received from server");
      }

      Cookies.set("authToken", data.access, { expires: 7 });
      setIsLoggedIn(true);
      setUserPermissions(data.userAbilities);
      setUserData(data.userData);
      setIsFirstLogin(data.is_firstlogin);
      setUserProfile(data.userProfileData);
      setDashboardRedirection(data.userData.dashboard_priority);
    } catch (err) {
      if (err instanceof Error) {
      } else {
      }
    } finally {
      setIsLoading(false);

    }
  };

  const handlePasswordUpdate = async (e: { preventDefault: () => void }) => {
    const jwtToken = Cookies.get("authToken");
    setIsLoading(true);
    e.preventDefault();
    try {
      const response = await fetch(
        `${webApi}/user/change_password_first_login/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            new_password: newPassword,
            confirm_password: confirmPassword,
          }),
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData);
        throw new Error(errorData.detail || "Failed to update password");
      }
      const submitBtn1 = document.getElementById("submit-btn7");
      if (submitBtn1) {
        submitBtn1.setAttribute("data-bs-dismiss", "modal");
        submitBtn1.click();
      }
      navigateToDashboard();
    } catch (err) {
      if (err instanceof Error) {
      } else {
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="container-fuild">
        <div className="login-wrapper w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
          <div className="row">
            <div className="col-lg-6">
              <div className="d-lg-flex align-items-center justify-content-center  d-lg-block d-none flex-wrap vh-100">
                <div>
                  <img
                    src="\assets\img\login.png"
                    alt="Img"
                    style={{ height: "55vh" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
                <div className="col-md-6 mx-auto p-4">
                  <form onSubmit={handleSubmit}>
                    <div>
                      <div
                        className="card"
                      // style={{
                      //   width: width <= 768 ? "100%" : "70%",

                      // }}
                      >
                        <div className="card-body p-4">
                          <div className=" mb-4">
                            <div className="d-flex align-items-center mb-3 justify-content-center">
                              {/* <img
                                src="https://cmstage.s3.ap-south-1.amazonaws.com/stage/assets/logo.png"
                                className="img-fluid"
                                alt="Logo"
                                style={{ height: "55px", marginRight: "5px" }}  
                              />
                              <h1 className="ml-3">Sri Chaitanya</h1> */}
                              <img src="/assets/img/Youtube_CP%20copy%204@4x.png" alt="Description" />

                            </div>
                          </div>

                          <div className="mb-3 ">
                            <label className="form-label">User Name</label>
                            <div className="input-icon mb-3 position-relative">
                              {!errorMessage.username && (
                                <span className="input-icon-addon">
                                  <i className="ti ti-mail" />
                                </span>
                              )}
                              <input
                                type="text"
                                className={`form-control ${errorMessage.username
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                placeholder="Enter your username"
                              />
                              {errorMessage.username && (
                                <div className="invalid-feedback">
                                  {errorMessage.username[0]}
                                </div>
                              )}
                            </div>
                            <label className="form-label">Password</label>
                            <div className="pass-group">
                              <input
                                type={
                                  passwordVisibility.password
                                    ? "text"
                                    : "password"
                                }
                                className={`form-control ${errorMessage.password ? "is-invalid" : ""
                                  }`}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Enter your password"
                              />
                              {errorMessage.password && (
                                <div className="invalid-feedback">
                                  {errorMessage.password[0]}
                                </div>
                              )}
                              <span
                                className={`ti toggle-passwords ${passwordVisibility.password
                                  ? "ti-eye"
                                  : "ti-eye-off"
                                  }`}
                                onClick={() =>
                                  togglePasswordVisibility("password")
                                }
                              ></span>
                            </div>
                          </div>

                          <div className="mb-3">
                            <button
                              type="submit"
                              className="btn btn-primary w-100"
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <i className="spinner-border spinner-border-sm"></i>
                              ) : (
                                <>Sign In</>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal fade" id="updatepassword">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">Change Password</h4>
                    <button
                      type="button"
                      className="btn-close custom-btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="submit-btn7"
                      onClick={() => setIsFirstLogin(undefined)}
                    >
                      <i className="ti ti-x" />
                    </button>
                  </div>
                  <form onSubmit={handlePasswordUpdate}>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">New Password</label>
                            <div className="pass-group">
                              <input
                                type={
                                  passwordVisibility.newPassword
                                    ? "text"
                                    : "password"
                                }
                                className={`form-control ${errorMessage.error ? "is-invalid" : ""
                                  }`}
                                name="new_password"
                                placeholder="New Password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                              />
                              {errorMessage.error && (
                                <div className="invalid-feedback">
                                  {errorMessage.error}
                                </div>
                              )}
                              <span
                                className={`ti toggle-passwords ${passwordVisibility.newPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                                  }`}
                                onClick={() =>
                                  togglePasswordVisibility("newPassword")
                                }
                              ></span>
                            </div>
                          </div>
                          <div className="mb-0">
                            <label className="form-label">
                              Confirm Password
                            </label>
                            <div className="pass-group">
                              <input
                                type={
                                  passwordVisibility.confirmPassword
                                    ? "text"
                                    : "password"
                                }
                                className={`form-control ${errorMessage.error ? "is-invalid" : ""
                                  }`}
                                name="confirm_password"
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) =>
                                  setConfirmPassword(e.target.value)
                                }
                                required

                              />
                              {errorMessage.error && (
                                <div className="invalid-feedback">
                                  {errorMessage.error}
                                </div>
                              )}
                              <span
                                className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                                  }`}
                                onClick={() =>
                                  togglePasswordVisibility("confirmPassword")
                                }
                              ></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="submit" className="btn btn-primary">
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login2;
